import { id } from "date-fns/locale";
import { ENDPOINTS, getFullUrl } from "../config";
import {
  DriverListApiResponse,
  LabTestByIdApiResponse,
  LabTestByIdData,
  LabTestCategoriesResponse,
  labtestListingResponse,
  LabTestOptionsListingResponse,
  LabTestOptionsResponse,
  LabtestOrderListing,
  LabtestTypesResponse,
  ListingApiResponse,
} from "./types";

export class LabService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }
  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getLabTestCategories(
    isHealthPackage: boolean = false,
  ): Promise<LabTestCategoriesResponse> {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.LAB.GETLABCATEGORIES,
      )}?isHealthPackage=${isHealthPackage}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch lab test categories:", error);
      throw error;
    }
  }

  static async getLabTestTypes(
    page = 1,
    pageSize = 10,
    name?: string,
  ): Promise<LabtestTypesResponse> {
    try {
      const url = `${getFullUrl(ENDPOINTS.LAB.GETLABTYPES)}`;
      const params = new URLSearchParams({
        page: page.toString(),
        limit: pageSize.toString(),
      });
      if (name) {
        params.set("name", name);
      }
      const response = await fetch(`${url}?${params.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to fetch lab test types:", error);
      throw error;
    }
  }

  static async getLabTestOptions(
    page = 1,
    pageSize = 10,
    name?: string,
  ): Promise<LabTestOptionsResponse> {
    try {
      const url = getFullUrl(ENDPOINTS.LAB.GETLABTESTOPTIONS);
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
      if (name) {
        params.set("name", name);
      }
      const response = await fetch(`${url}?${params.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch lab test options:", error);
      throw error;
    }
  }

  static async addLabtest(data: any) {
    try {
      const url = getFullUrl(ENDPOINTS.LAB.ADDLABTEST);
      //const url=`http://localhost:3005/inventoryorderservice/labtest/create`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to add lab test:", error);
      throw error;
    }
  }

  static async updateLabTest(id: number, data: any) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.LAB.UPDATELABTEST.replace(":id", id.toString())}`,
      );
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to update lab test:", error);
      throw error;
    }
  }

  static async getLabtestListing(
    page = 1,
    pageSize = 10,
    isHealthPackage: boolean,
    type: string,
    name?: string,
  ): Promise<labtestListingResponse> {
    try {
      const url = getFullUrl(ENDPOINTS.LAB.LABTESTLISTING);
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        isHealthPackage: isHealthPackage.toString(),
        type: type.toString(),
      });
      if (name) {
        params.set("name", name);
      }
      const response = await fetch(`${url}?${params.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to fetch lab test listing:", error);
      throw error;
    }
  }

  static async getLabtestOptionsListing(
    page = 1,
    pageSize = 10,
    type: string,
    name?: string,
  ): Promise<LabTestOptionsListingResponse> {
    try {
      const url = getFullUrl(`${ENDPOINTS.LAB.GETLABTESTOPTIONS}`);
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        type: type.toString(),
      });
      if (name) {
        params.set("name", name);
      }
      const response = await fetch(`${url}?${params.toString()}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch lab test options:", error);
      throw error;
    }
  }

  static async getLabOrdersListing(
    page = 1,
    pageSize = 10,
    clinicId: string,
    status: string,
    searchText: string,
  ): Promise<{
    success: boolean;
    message?: string;
    data: LabtestOrderListing;
  }> {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (clinicId) {
        params.set("clinicId", clinicId);
      }

      if (status) {
        params.set("status", status);
      }

      if (searchText) {
        params.set("name", searchText);
      }

      const url = `${getFullUrl(
        ENDPOINTS.LAB.GETLABTESTLISTING,
      )}?${params.toString()}`;

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }

  static async getAdminLabtestOrderListing(
    page = 1,
    pageSize = 10,
    status: string,
    clinicId?: string,
    searchText?: string,
  ): Promise<{
    success: boolean;
    message?: string;
    data: {
      ordersList: any[];
      pagination: {
        page: number;
        pageSize: number;
        totalPages: number;
        totalCount: number;
      };
    };
  }> {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        status,
      });

      if (clinicId) {
        params.set("clinicId", clinicId);
      }

      if (searchText) {
        params.set("searchText", searchText);
      }

      const url = `${getFullUrl("/orderservice/admin-order/labtest-order-listing")}?${params.toString()}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch admin labtest listing:", error);
      throw error;
    }
  }

  static async prepareLabtestOrder(data: {
    orderId: number;
    orderTotal: number;
    labtests: {
      labTestId: number;
      price: number;
      timeSlot: string;
      date: string;
      bookingPatientId: string;
    }[];
  }): Promise<{ success: boolean; message: string }> {
    try {
      const url = getFullUrl("/orderservice/admin-order/prepare-labtest-order");
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to prepare labtest order:", error);
      throw error;
    }
  }

  static async getLabtestDetailsById(id: number): Promise<LabTestByIdData> {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.LAB.GETLABTESTDETAILSBYID.replace(":id", id.toString())}`,
      );

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      const res = await response.json();
      return res.data;
    } catch (error) {
      console.error("Failed to fetch lab test details:", error);
      throw error;
    }
  }

  static async getLabOrderDetails(orderId: number) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.LAB.GETLABTESTDETAILS.replace(":orderId", orderId.toString())}`,
      );

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }

  static async updateLabOrder(orderId: number, image: File[]) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.LAB.UPLOADDOCUMENTS.replace(":orderId", orderId.toString())}`,
      );

      const formData = new FormData();
      for (const file of image) {
        formData.append("image", file);
      }

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          // Don't set Content-Type - let the browser set it automatically
        },
        body: formData, // Send the FormData directly
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to update lab order:", error);
      throw error;
    }
  }

  static async updateLabStatus(id: number, status: string): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.LAB.UPDATESTATUS}`);
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({ orderId: id, status }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to update lab order:", error);
      throw error;
    }
  }

  static async updateTests(data: any): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.LAB.ADDTESTS}`);
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to update lab order:", error);
      throw error;
    }
  }

  static async getAvailableDrivers(
    clinicId: string,
    type: string,
  ): Promise<DriverListApiResponse> {
    try {
      const params = new URLSearchParams({
        clinicId,
        type,
      });
      const url = getFullUrl(
        `${ENDPOINTS.DRIVER.GETAVAILABLEDRIVER}?${params.toString()}`,
      );
      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch driver list:", error);
      throw error;
    }
  }

  static async assignDriver(data: {
    orderId: number;
    driverId: string;
  }): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.LAB.ASSIGNDRIVER}`);
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to assign driver:", error);
      throw error;
    }
  }

  static async forwardToLab(orderId: number): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.LAB.FORWARDTOLAB}`);
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({ orderId }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`,
        );
      }
      return await response.json();
    } catch (error) {
      console.error("Failed to forward to lab:", error);
      throw error;
    }
  }
}
